import { render, staticRenderFns } from "./OverwatchCard.vue?vue&type=template&id=a3738dca&scoped=true&"
import script from "./OverwatchCard.vue?vue&type=script&lang=js&"
export * from "./OverwatchCard.vue?vue&type=script&lang=js&"
import style0 from "./OverwatchCard.vue?vue&type=style&index=0&id=a3738dca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3738dca",
  null
  
)

export default component.exports